export default "__VITE_ASSET__WFlCUCG6__"